<div class="container">

	<h1 class="center"> Modification de la commande </h1>
	<h2 *ngIf="canEditSend" class="center"> (Commande déjà transmise)
		<mat-icon matTooltip="Vous pouvez uniquement augmenter les quantités transmises">
			help
		</mat-icon>
	</h2>

	<div *ngIf="loading; else commandeEditTemplate" class="flex justify-center">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #commandeEditTemplate>
		<form [formGroup]="group" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
			<section>
				{{ curDay | titlecase }}
				<mat-form-field>
					<input disabled matInput value="{{commandeDetails.date_livraison}}" [matDatepicker]="picker"
						placeholder="Date de livraison">
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker startView="month"></mat-datepicker>
				</mat-form-field>

				<mat-checkbox matTooltip="Les quantités des articles seront passées à 0" matTooltipPosition="above"
					class="ml-2.5" (click)="updateQuantities($event)" [checked]="isQuantitiesAt0">
					Pas de commande
				</mat-checkbox>
			</section>

			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th>Quantité max</th>
						<th *ngIf="enabledConditionnement">Conditionnement</th>
						<th *ngIf="canEditSend">Quantité transmise</th>
						<th>Quantité *</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let article of commandeDetails.lod_ligne_commandes">
						<td>{{ article.article.designation }}</td>
						<td>{{ getQuantityMax(article) }}</td>
						<td *ngIf="enabledConditionnement">{{ article.qte_conditionnement ?? 'Non Renseigné' }}</td>
						<td *ngIf="canEditSend">{{ getQuantityTransmise(article) }}</td>
						<td>
							<mat-form-field>
								<mat-label></mat-label>
								<input type="number" matInput [value]="article.quantite" min="0" [disabled]="article?.qte_stock == 0"
									max="getQuantityMax(article)" (change)="updateValue(article, $event)" #txtInput
									(keydown.enter)="txtInput.blur()">
							</mat-form-field>
						</td>
						<mat-icon *ngIf="article?.qte_stock == 0" class="warning-stock"
							matTooltip="Cet article n'est actuellement pas en stock, il n'est donc pas commandable">
							warning
						</mat-icon>
					</tr>
				</tbody>
			</table>

			<div class="pt-2.5">* Les quantités livrées pourront être ajustées au plus près des quantités
				commandées, au moment de la préparation, pour garantir une livraison dans les meilleurs délais.</div>

			<div class="buttons-center">
				<button mat-raised-button type="button" (click)="refuse()" color="white">Annuler</button>
				<button mat-raised-button type="submit" [disabled]="saving || this.commandeDetails.statut.code == 'DD'"
					*ngIf="!canEditSend">
					Enregistrer
				</button>
				<button mat-raised-button type="button" (click)="openDialog()" [disabled]="saving">
					Enregistrer & Transmettre
				</button>
			</div>
		</form>
	</ng-template>
</div>